export default "__VITE_ASSET__B_MdeL7d__"